import { Component } from '@angular/core';

@Component({
  selector: 'uni-title-item',
  templateUrl: './uni-title-item.component.html',
  styleUrls: ['./uni-title-item.component.scss'],
})
export class UniTitleItemComponent {}
